import { Record } from 'immutable';
export default Record({
  boundary: 'ON',
  execTimeInMinutes: 720
});